// extracted by mini-css-extract-plugin
module.exports = {"container":"e_otb","icon":"e_ptb"};